import {Checkbox} from "antd"
import {useMutation, useQueryClient} from "@tanstack/react-query"
import {handleError} from "helpers"
import {
    HIDE_FUNNEL_IN_STUDENT_DETAILS_QUERY_KEY,
    useHideFunnelInStudentDetails
} from "hooks/useHideFunnelInStudentDetails"
import {generalSettingsService} from "services"
import {YesNo} from "types/common"
import {GeneralSettingField} from "types/settings/general-setting"
import styles from "./HideFunnelInStudentDetails.module.css"

export const HideFunnelInStudentDetails = () => {
    const queryClient = useQueryClient()
    const {hideFunnelInStudentDetails, isLoadingHideFunnelSetting} = useHideFunnelInStudentDetails()

    const updateSettingMutation = useMutation(
        async (checked: boolean) => {
            await generalSettingsService.updateSettings([
                {
                    field: GeneralSettingField.AdmHideFunnelInStudentDetails,
                    value: checked ? YesNo.Yes : YesNo.No
                }
            ])
        },
        {
            onMutate: async (checked) => {
                await queryClient.cancelQueries({queryKey: HIDE_FUNNEL_IN_STUDENT_DETAILS_QUERY_KEY})
                const previousSettings = queryClient.getQueryData(HIDE_FUNNEL_IN_STUDENT_DETAILS_QUERY_KEY)
                queryClient.setQueryData(HIDE_FUNNEL_IN_STUDENT_DETAILS_QUERY_KEY, [
                    {
                        field: GeneralSettingField.AdmHideFunnelInStudentDetails,
                        value: checked ? YesNo.Yes : YesNo.No
                    }
                ])
                return {previousSettings}
            },
            onError: (error, _checked, context) => {
                queryClient.setQueryData(HIDE_FUNNEL_IN_STUDENT_DETAILS_QUERY_KEY, context?.previousSettings)
                handleError(error)
            },
            onSettled: () => {
                queryClient.invalidateQueries({queryKey: HIDE_FUNNEL_IN_STUDENT_DETAILS_QUERY_KEY})
            }
        }
    )

    return (
        <div className={styles.container}>
            <Checkbox
                checked={hideFunnelInStudentDetails}
                disabled={isLoadingHideFunnelSetting || updateSettingMutation.isLoading}
                onChange={(event) => updateSettingMutation.mutate(event.target.checked)}>
                Hide funnel in admission student details
            </Checkbox>
        </div>
    )
}
